var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconFeedComment = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15C21 15.5305 20.7893 16.0392 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21L3 5.00003C3 4.4696 3.21071 3.96089 3.58579 3.58582C3.96086 3.21074 4.46957 3.00003 5 3.00003L19 3.00003C19.5304 3.00003 20.0391 3.21074 20.4142 3.58582C20.7893 3.96089 21 4.4696 21 5.00003L21 15Z",
    stroke: "#808080",
    strokeWidth: 1.89474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFeedComment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconFeedComment.47e91e2d.svg";
export { ForwardRef as ReactComponent };